import { Row, Card } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import {useState, useEffect} from 'react';

import ResultStyle from '../../styles/ExpressPolicyResults.module.css'

const ExpressPolicyResults = () => {
  const [policyChangeType, setPolicyChangeType] = useState('');
  useEffect(() => {
    setPolicyChangeType(localStorage.getItem('expressPolicyChangeType'));
  }, [])
  
  return (
    <div className="container">
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Thanks for your online policy change request." />
        <div className={`${ResultStyle["express-policy-results"]}`}>
          <Row>
            <Card className={`${ResultStyle["register-card"]}`}>
              <span className={`${ResultStyle["link-text"]}`} style={{color: 'black !important'}}>
                We have received your online policy change request for {policyChangeType}. 
              </span>
              <span className={`${ResultStyle["link-text"]}`} style={{color: 'black !important'}}>
                What’s next? Keep an eye on your email!
              </span>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', width: '100%' }}>
                <li style={{   color: 'black', fontFamily: 'GlacialInDifference', fontStyle: 'normal', fontWeight: 400, marginLeft: '4%', fontSize: '20px', marginBottom: '12px'  }}>The policy change may affect your premium, please login after the change is approved to view your updated payment amount due. You will receive your updated ID card(s) and declarations page by email or mail depending on your policy preference.</li>
                <div style={{   color: 'black', fontFamily: 'GlacialInDifference', fontStyle: 'normal', fontWeight: 400, marginLeft: '4%', fontSize: '20px'  }}>These documents will also be available in the   
                  <a href="https://www.cure.com/download-mobile-app" style={{ textDecoration: 'underline', color: 'black !important', marginLeft: '5px', marginRight: '5px' }} target="_blank" rel="noopener noreferrer">CURE App</a> 
                  and 
                  <a href="https://www.cure.com/my-account" style={{ textDecoration: 'underline', color: 'black !important', marginLeft: '5px' }} target="_blank" rel="noopener noreferrer">My Account</a>.
                </div>
                <li style={{   color: 'black', fontFamily: 'GlacialInDifference', fontStyle: 'normal', fontWeight: 400, marginLeft: '4%', fontSize: '20px', marginBottom: '12px', marginTop: '12px'  }}>If we need additional information prior to processing this change, we will email you as soon as possible.</li>
              </ul>
              <span className={`${ResultStyle["link-text"]}`} style={{color: 'black !important'}}>
                Drive well.
              </span>
            </Card>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

ExpressPolicyResults.propTypes = {}

export default ExpressPolicyResults
